import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'reset-confirmation-modal',
  templateUrl: './reset-confirmation-modal.component.html',
  styleUrls: ['./reset-confirmation-modal.component.scss'],
})
export class ResetConfirmationModalComponent implements OnInit {
  @Output()
  resetInvoices: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor() {}

  ngOnInit(): void {}

  reset() {
    this.resetInvoices.emit(true);
  }
}
